<template>
  <div id="app">
    <partone></partone>
    <parttwo></parttwo>
    <partthree></partthree>
    <partfour></partfour>
    <partfive></partfive>
    <partsix></partsix>
    <partseven></partseven>
    <parteight></parteight>
  </div>
</template>

<script>
import PartOne from './components/PartOne'
import Parttwo from './components/Parttwo'
import Partthree from './components/Partthree'
import Partfour from './components/Partfour'
import Partfive from './components/Partfive'
import Partsix from './components/Partsix'
import Partseven from './components/Partseven'
import Parteight from './components/Parteight'

export default {
  name: 'App',
  components: {
    'partone' : PartOne,
    'parttwo' : Parttwo,
    'partthree' : Partthree,
    'partfour' : Partfour,
    'partfive' : Partfive,
    'partsix' : Partsix,
    'partseven' : Partseven,
    'parteight' : Parteight
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
.v-modal{
  opacity: 0.7 !important;
}
.el-dialog{
  background: transparent !important;
  box-shadow: none;
}
.el-dialog__body{
  padding: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue